"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var iconFactory_1 = require("../../utils/iconFactory");
// AEM-Name: FolderIcon
exports.FolderIcon = iconFactory_1.iconFactory({
    componentName: 'FolderIcon',
    viewBox: '0 0 32 32',
    title: 'FolderIcon',
    g: "<g>\n<path d=\"M27.872 9.6h-15.52v-2.752c0-0.512-0.416-0.928-0.928-0.928h-7.296c-0.512 0-0.928 0.416-0.928 0.928v18.272c0 0.512 0.416 0.928 0.928 0.928h23.776c0.512 0 0.928-0.416 0.928-0.928v-14.592c-0.032-0.512-0.448-0.928-0.96-0.928zM14.176 17.824h-7.328v-3.648h7.328v3.648z\"/>\n</g>",
    gThemed: { "ergo-one": { "viewBox": "0 0 32 32", "g": "<g><path d=\"M27.872 9.6h-15.52v-2.752c0-0.512-0.416-0.928-0.928-0.928h-7.296c-0.512 0-0.928 0.416-0.928 0.928v18.272c0 0.512 0.416 0.928 0.928 0.928h23.776c0.512 0 0.928-0.416 0.928-0.928v-14.592c-0.032-0.512-0.448-0.928-0.96-0.928zM14.176 17.824h-7.328v-3.648h7.328v3.648z\"/></g>" } }
});
exports.default = exports.FolderIcon;
//# sourceMappingURL=FolderIcon.js.map